export default __webpack_public_path__ + "static/media/ml.ec3e33fc.jpg";